<template>
  <div id="app">
    <Transition name="fade" mode="out-in">
      <div v-if="!isLoading">
        <router-view />
      </div>
    </Transition>
    <Transition name="fade" mode="out-in">
      <!-- 
      <div class="loader" v-if="isLoading">
        <div class="semipolar-spinner">
          <div class="ring"></div>
          <div class="ring"></div>
          <div class="ring"></div>
        </div>
      </div> 
      -->
      <div class="loader-container" v-if="isLoading">
        <img
          src="@/assets/img/Loader-HCM.gif"
          alt="Loading..."
          class="loader-gif"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ThemeService from "./services/ThemeService";
import "vue-toast-notification/dist/theme-default.css";

import { notification } from "ant-design-vue";
import loaderGif from "@/assets/img/Loader-HCM.gif";

export default {
  components: {},
  data() {
    return {
      theme: {},
      sidebarTheme: {},
      loaderSrc: require("@/assets/img/Loader-HCM.gif"),
      isGlobalVariant: process.env.VUE_APP_VARIANT !== "default",
      isAppedologyVariant: process.env.VUE_APP_VARIANT === "appedology",
      isProGlobalVariant: process.env.VUE_APP_VARIANT === "proglobal",
    };
  },
  async beforeMount() {
    // await this.$store.dispatch("auth/checkAuth");
  },
  methods: {
    // Theme using API
    getTheme() {
      const primaryColor = localStorage.getItem("primary-color");
      const secondaryColor = localStorage.getItem("secondary-color");
      if (primaryColor) {
        document.documentElement.style.setProperty(
          "--primary-color",
          primaryColor
        );
      }
      if (secondaryColor) {
        document.documentElement.style.setProperty(
          "--secondary-color",
          secondaryColor
        );
      }
      // try {
      //   await this.$store.dispatch("auth/checkAuth");
      //   if (this.isAuthenticated) {
      //     const response = await ThemeService.fetchTheme();
      //     this.theme = response.data[0];
      //     const responseSb = await ThemeService.fetchSidebarTheme();
      //     this.sidebarTheme = responseSb.data[0];
      //   } else {
      //     const response = await ThemeService.fetchThemeById(1);
      //     this.theme = response.data;
      //   }
      //   // Sidebar Theme
      //   if (this.sidebarTheme && this.sidebarTheme.color) {
      //     document.documentElement.style.setProperty(
      //       "--sb-color",
      //       this.sidebarTheme?.color
      //     );
      //   }
      //   // Solid Theme
      //   if (this.theme && this.theme.type == "solid") {
      //     document.documentElement.setAttribute(
      //       "layout-mode",
      //       this.theme?.type
      //     );
      //   }
      //   if (this.theme && this.theme.solid_color) {
      //     document.documentElement.style.setProperty(
      //       "--bg-color",
      //       this.theme?.solid_color
      //     );
      //   }
      //   // Gradient Theme
      //   if (this.theme && this.theme.gradient_color_1) {
      //     document.documentElement.style.setProperty(
      //       "--color-1",
      //       this.theme?.gradient_color_1
      //     );
      //   }
      //   if (this.theme && this.theme.gradient_color_2) {
      //     document.documentElement.style.setProperty(
      //       "--color-2",
      //       this.theme?.gradient_color_2
      //     );
      //   }
      //   if (this.theme && this.theme.gradient_degree) {
      //     document.documentElement.style.setProperty(
      //       "--degree",
      //       `${this.theme?.gradient_degree}deg`
      //     );
      //   }
      // } catch (error) {
      //   console.error("error fetching theme", error);
      // }
    },
    getOrganizationTheme() {
      const primaryColor = this.isProGlobalVariant
        ? "#186997"
        : this.isAppedologyVariant
        ? "#9E252E"
        : localStorage.getItem("primary-color");
      const secondaryColor = this.isProGlobalVariant
        ? "rgba(24,105,151,0.55)"
        : this.isAppedologyVariant
        ? "rgba(158, 37, 46, 0.55)"
        : localStorage.getItem("secondary-color");
      if (primaryColor) {
        document.documentElement.style.setProperty(
          "--primary-color",
          primaryColor
        );
      }
      if (secondaryColor) {
        document.documentElement.style.setProperty(
          "--secondary-color",
          secondaryColor
        );
      }
    },
    // Theme using localhost
    // async getTheme() {
    //   const primaryColor = localStorage.getItem("primary-color");
    //   const secondaryColor = localStorage.getItem("secondary-color");

    //   if (primaryColor) {
    //     document.documentElement.style.setProperty(
    //       "--primary-color",
    //       primaryColor
    //     );
    //   }
    //   if (secondaryColor) {
    //     document.documentElement.style.setProperty(
    //       "--secondary-color",
    //       secondaryColor
    //     );
    //   }
    // },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      setTimeout(() => {
        this.isLoading = false;
      }, 500); // Simulate loading time
    },
  },
  computed: {
    // map vuex getters to the local computed values
    ...mapState("auth", ["isLoading"]),
    ...mapState("auth", ["isAuthenticated"]),
  },
  async created() {
    this.getOrganizationTheme();
    this.getTheme();

    // Notifications Channel Connection
    // const userId = this.$store.state.auth.user.id;

    // this.$store.dispatch("listenForNotifications", userId);

    // // Listen for store changes to trigger toasts
    // this.$watch(
    //   () => this.$store.getters["notifications/allNotifications"],
    //   (newNotifications) => {
    //     const latestNotification =
    //       newNotifications[newNotifications.length - 1];
    //     notification.open({
    //       title: latestNotification.title,
    //       message: latestNotification.message,
    //       placement: "bottomRight",
    //       bottom: "50px",
    //       duration: 3,
    //       style: {
    //         width: "350px",
    //         marginLeft: `${335 - 600}px`,
    //         background: "#2ab57d",
    //       },
    //     });
    //   }
    // );
    // Notifications Channel Connection
  },
  watch: {
    isLoading(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.loaderSrc = require("@/assets/img/Loader-HCM.gif"); // Ensure the GIF reloads if needed
        });
      }
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.$store.commit("auth/loading", false);
    }
    this.$router.beforeEach((to, from, next) => {
      this.startLoading();
      next();
    });

    this.$router.afterEach(() => {
      this.stopLoading();
    });
  },

  // ------- Close all Inspect Options other than developers tool option --------

  // setup() {
  //   document.addEventListener("contextmenu", function (e) {
  //     e.preventDefault();
  //   });
  //   document.onkeydown = (e) => {
  //     console.log("e", e.key);
  //     if (e.key == "F12") {
  //       e.preventDefault();
  //     }
  //     if (e.ctrlKey && e.shiftKey && (e.key == "I" || e.key == "i")) {
  //       e.preventDefault();
  //     }
  //     if (e.ctrlKey && e.shiftKey && (e.key == "C" || e.key == "c")) {
  //       e.preventDefault();
  //     }
  //     if (e.ctrlKey && e.shiftKey && (e.key == "J" || e.key == "j")) {
  //       e.preventDefault();
  //     }
  //     if (e.ctrlKey && (e.key == "U" || e.key == "u")) {
  //       e.preventDefault();
  //     }
  //   };
  // },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}
.loader-gif {
  width: 100px;
  height: 100px;
}
/* Loader */
.loader {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: red;
}
.semipolar-spinner,
.semipolar-spinner * {
  box-sizing: border-box;
}

.semipolar-spinner {
  height: 65px;
  width: 65px;
  position: relative;
}

.semipolar-spinner .ring {
  border-radius: 50%;
  position: absolute;
  border: calc(65px * 0.05) solid transparent;
  border-top-color: var(--color-1);
  border-left-color: var(--color-2);
  animation: semipolar-spinner-animation 2s infinite;
}
[layout-mode="solid"] .semipolar-spinner .ring {
  border-top-color: var(--bg-color);
  border-left-color: var(--bg-color);
}

.semipolar-spinner .ring:nth-child(1) {
  height: calc(65px - 65px * 0.2 * 0);
  width: calc(65px - 65px * 0.2 * 0);
  top: calc(65px * 0.1 * 0);
  left: calc(65px * 0.1 * 0);
  animation-delay: calc(2000ms * 0.1 * 4);
  z-index: 5;
}

.semipolar-spinner .ring:nth-child(2) {
  height: calc(65px - 65px * 0.2 * 1);
  width: calc(65px - 65px * 0.2 * 1);
  top: calc(65px * 0.1 * 1);
  left: calc(65px * 0.1 * 1);
  animation-delay: calc(2000ms * 0.1 * 3);
  z-index: 4;
}

.semipolar-spinner .ring:nth-child(3) {
  height: calc(65px - 65px * 0.2 * 2);
  width: calc(65px - 65px * 0.2 * 2);
  top: calc(65px * 0.1 * 2);
  left: calc(65px * 0.1 * 2);
  animation-delay: calc(2000ms * 0.1 * 2);
  z-index: 3;
}

.semipolar-spinner .ring:nth-child(4) {
  height: calc(65px - 65px * 0.2 * 3);
  width: calc(65px - 65px * 0.2 * 3);
  top: calc(65px * 0.1 * 3);
  left: calc(65px * 0.1 * 3);
  animation-delay: calc(2000ms * 0.1 * 1);
  z-index: 2;
}

.semipolar-spinner .ring:nth-child(5) {
  height: calc(65px - 65px * 0.2 * 4);
  width: calc(65px - 65px * 0.2 * 4);
  top: calc(65px * 0.1 * 4);
  left: calc(65px * 0.1 * 4);
  animation-delay: calc(2000ms * 0.1 * 0);
  z-index: 1;
}

@keyframes semipolar-spinner-animation {
  50% {
    transform: rotate(360deg) scale(0.7);
  }
}
</style>
